import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ApplicationRoute } from '../../../constants/routes';
import BaseController from '../../BaseController';

@Controller({ component: 'layout-general', fragment: 'user-details' })
class UserDetailsController extends BaseController {

  @OnMount({ target: ['layout-general'] })
  onMount(): void {
    this.historyService.push(ApplicationRoute.USER_DETAILS);
  }
}
export default UserDetailsController;
